import { Radio, Space } from "antd";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Question } from "@types";

interface Props {
  question: Question;
}

export const SingleChoiceOption = ({question}: Props) => {

  const [value, setValue] = useState<string>(question.playerAnswers?.[0]?.id || "");

  useEffect(() => {
    if (question) {
      setValue((question?.playerAnswers?.[0]?.id) || "");
    }
  }, [question])

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Radio.Group value={value}>
        <Space direction="vertical">
          {question.answers.map((answer, index) => (
            <Radio
              value={answer.id}
              key={index}
              style={{
                color: answer.isCorrect ? "green" : value === answer.id ? "red" : "unset",
                fontWeight: answer.isCorrect ? "bold" : value === answer.id ? "bold" : "normal",
              }}
            >
              {answer.value}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </motion.div>
  );
};
